{
  "TRANSFER_TO_AGENT": {
    "TOOLTIP": "Передати оператору",
    "MESSAGE": "З'єднайте мене з оператором"
  },
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Звантажити",
      "UPLOADING": "Завантажується..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Додати"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Надіслати ще раз",
      "ERROR_MESSAGE": "Не вдалося надіслати, спробуйте ще раз"
    },
    "MESSAGE_RATING": {
      "TOOLTIP": "Оцініть якість цієї відповіді"
    }
  },
  "WAITING_FOR_AGENT": {
    "MESSAGE": "Будь ласка, зачекайте, поки приєднається агент"
  },
  "ROBOT_CHECK": {
    "TITLE": "Швидка перевірка безпеки",
    "DESCRIPTION": "Будь ласка, пройдіть перевірку нижче.",
    "VERIFYING": "Перевіряється…",
    "ERROR": "Це не спрацювало. Спробуйте ще раз.",
    "RETRY": "Спробувати ще раз"
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "Ми онлайн",
    "OFFLINE": "Нас наразі немає",
    "ONLINE_WITH_BOT": "Команда та наш помічник ШІ онлайн",
    "OFFLINE_WITH_BOT": "Наш помічник ШІ тут, щоб допомогти",
    "BOT_ONLY_REPLY": "Відповідає негайно"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Зазвичай, відповідаємо за декілька хвилин",
    "IN_A_FEW_HOURS": "Зазвичай, відповідаємо за декілька годин",
    "IN_A_DAY": "Зазвичай, відповідаємо протягом доби",
    "BACK_IN": "Ми повернемось в мережу"
  },
  "DAY_NAMES": {
    "SUNDAY": "Неділя",
    "MONDAY": "Понеділок",
    "TUESDAY": "Вівторок",
    "WEDNESDAY": "Середа",
    "THURSDAY": "Четвер",
    "FRIDAY": "П'ятниця",
    "SATURDAY": "Субота"
  },
  "START_CONVERSATION": "Розпочати розмову",
  "END_CONVERSATION": "Закінчити спілкування",
  "CONTINUE_CONVERSATION": "Продовжити спілкування",
  "YOU": "Ви",
  "START_NEW_CONVERSATION": "Розпочати нову розмову",
  "RESOLVE_LATER": "Цю тему вирішимо електронною поштою/телефоном. Зараз хочу запитати про щось інше.",
  "VIEW_UNREAD_MESSAGES": "У Вас є непрочитані повідомлення",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Переглянути нові повідомлення",
    "CLOSE_MESSAGES_BUTTON": "Закрити",
    "COMPANY_FROM": "від",
    "BOT": "Бот"
  },
  "BUBBLE": {
    "LABEL": "Почніть розмову з нами"
  },
  "POWERED_BY": "Працює на {brandName}",
  "EMAIL_PLACEHOLDER": "Введіть адресу електронної пошти",
  "CHAT_PLACEHOLDER": "Введіть Ваше повідомлення",
  "TODAY": "Сьогодні",
  "YESTERDAY": "Вчора",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Повне ім`я",
        "PLACEHOLDER": "Будь ласка, введіть своє повне ім'я",
        "REQUIRED_ERROR": "Потрібне повне ім'я"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Адреса електронної пошти",
        "PLACEHOLDER": "Будь ласка, введіть адресу вашої електронної пошти",
        "REQUIRED_ERROR": "Необхідно вказати адресу електронної пошти",
        "VALID_ERROR": "Будь ласка, введіть коректну адресу електронної пошти"
      },
      "PHONE_NUMBER": {
        "LABEL": "Номер телефону",
        "PLACEHOLDER": "Будь ласка, введіть номер телефону",
        "REQUIRED_ERROR": "Номер телефону є обов'язковим",
        "DIAL_CODE_VALID_ERROR": "Будь ласка, оберіть код країни",
        "VALID_ERROR": "Будь ласка, введіть правильний номер телефону",
        "DROPDOWN_EMPTY": "Результатів не знайдено",
        "DROPDOWN_SEARCH": "Пошук країни"
      },
      "MESSAGE": {
        "LABEL": "Текст повідомлення",
        "PLACEHOLDER": "Будь ласка, введіть ваше повідомлення",
        "ERROR": "Занадто коротке повідомлення"
      }
    },
    "CAMPAIGN_HEADER": "Будь ласка, надайте своє ім'я та електронну пошту перед початком бесіди",
    "IS_REQUIRED": "обов'язково",
    "REQUIRED": "Обов'язково",
    "REGEX_ERROR": "Будь ласка, введіть коректний текст"
  },
  "FILE_SIZE_LIMIT": "Файл перевищує ліміт вкладення {MAXIMUM_FILE_UPLOAD_SIZE}",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Невірно заповнене поле"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Пошук емодзі",
    "NOT_FOUND": "Немає емодзі, що відповідають пошуковому запиту",
    "ARIA_LABEL": "Вибір емодзі"
  },
  "CSAT": {
    "TITLE": "Оцініть вашу бесіду",
    "SUBMITTED_TITLE": "Дякуємо за оцінку",
    "PLACEHOLDER": "Розкажіть докладніше..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Запит на текст розмови",
    "SEND_EMAIL_SUCCESS": "Текст розмови надісланий",
    "SEND_EMAIL_ERROR": "Сталася помилка, будь ласка, спробуйте ще раз"
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Популярні статті",
    "VIEW_ALL_ARTICLES": "Переглянути всі статті",
    "IFRAME_LOAD_ERROR": "Помилка при завантаженні статті, будь ласка, оновіть сторінку та повторіть спробу."
  },
  "CARDS": {
    "ACTIONS": {
      "OPEN": "Відкрити",
      "BUY": "Купити"
    }
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Повідомлення з картинкою"
    },
    "audio": {
      "CONTENT": "Аудіо-повідомлення"
    },
    "video": {
      "CONTENT": "Відеоповідомлення"
    },
    "file": {
      "CONTENT": "Повідомлення з файлом"
    },
    "location": {
      "CONTENT": "Місцезнаходження"
    },
    "fallback": {
      "CONTENT": "поділився посиланням"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "Відповісти:"
  }
}
